<template>
  <div id="modal" />

  <div id="app-wrapper" :class="componentStyle">
    <Sidebar />

    <div id="toolbar" class="z-[51] bg-white" />
    <div
      :class="{
        'opacity-100': loading.isLoading.value,
      }"
      class="overflow-hidden opacity-0 sticky top-0 left-0 w-full z-10 h-1"
    >
      <div class="line absolute bg-primary-500/20 h-1"></div>
      <div class="absolute bg-primary-500 h-1 inc"></div>
      <div class="absolute bg-primary-500 h-1 dec"></div>
    </div>
    <main
      id="main"
      :class="[
        modalManager.modals.value.some((m) => m.isVisible)
          ? 'overflow-hidden'
          : 'overflow-auto',
      ]"
    >
      <slot />
    </main>

    <div id="drawer" class="shadow-lg overflow-y-auto" />
  </div>

  <div
    id="off-screen"
    class="overflow-hidden absolute top-0 left-0 -z-50"
  ></div>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue'
import Sidebar from './SideBar.vue'
import useModalManager from '@app/components/Global/Modal/modal-manager'
import useAiAssistant from '@app/composables/useAiAssistant'
import { injectStrict } from '@app/utils/injectStrict'
import { AuthKey } from '@app/injectionKeys'
import useLoading from '@app/composables/use-loading'
import { RouteName } from '@app/router'
import { useRoute } from 'vue-router'

const { init } = useAiAssistant()
const auth = injectStrict(AuthKey)
if (auth.user.value?.email) init()
const modalManager = useModalManager()
const isDarkMode = ref(false)
const loading = useLoading()
const route = useRoute()

onMounted(() => {
  const activeTheme = localStorage.getItem('theme')
  if (!activeTheme || activeTheme === 'light') {
    document.body.classList.remove('dark')
    isDarkMode.value = false
  } else {
    document.body.classList.add('dark')
    isDarkMode.value = true
  }
})

const componentStyle = computed(() => {
  return [
    RouteName.PROJECTS,
    RouteName.USERS,
    RouteName.SETTINGS,
    RouteName.REVIEW_EXECUTE_SCREENING,
    RouteName.REVIEW_EXECUTE_DATA_EXTRACTION,
    RouteName.REVIEW_EXECUTE_SYNTHESIS,
    RouteName.REVIEW_EXECUTE_APPRAISAL,
  ].includes(route.name as RouteName)
    ? 'bg-neutral-background-secondary'
    : ''
})
</script>
